<template>
  <div class="loading"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Loading',
})
</script>

<style lang="stylus">
.loading
  size 50px
  position relative
  margin auto

  &::before
    content ''
    absolute left 50% top 50%
    size 30px
    margin -20px 0 0 -20px
    border 5px solid var(--button-color)
    border-right-color transparent
    border-radius 50%
    animation rotate .5s linear infinite

@keyframes rotate
  from
    transform rotate(0deg)
  to
    transform rotate(360deg)
</style>
